import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from "react-chartjs-2";

// Register required components for Doughnut chart
ChartJS.register(ArcElement, Tooltip, Legend);

export default function NPSChart({ chartData, backgroundColor, color, loading, isSelfReport }) {
    const isSelfDataValid = chartData && chartData.length > 0;
    if (loading) {
        return (
          <div className="App h-w-100 white-color">
            <p className="text-black ms-4">Processing...</p>
          </div>
        );
    }
    if (!isSelfDataValid) {
        return <div className="App h-w-100 black-color">
            No data available!
        </div>;
    }

    

    const customPlugin = {
        id: 'customText',
        beforeDraw: (chart) => {
            const { ctx, chartArea } = chart;
            const { width, height } = chartArea;
            const centerX = width / 2;
            const centerY = height / 2;
            const fontSize = 80; //100;
            const npsValue = chartData ? parseFloat(chartData[0].nps).toFixed() : 0;

            ctx.save();
            ctx.font = `${fontSize}px Graphik-Light`;
            ctx.fillStyle = '#000000';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            // ctx.fillText((chartData ? parseFloat(chartData[0].nps).toFixed() : 0), centerX, centerY); // Display a custom value inside the chart
            const displayValue = npsValue >= 0 ? `+${npsValue}` : npsValue;
            ctx.fillText(displayValue, centerX, centerY); // Display a custom value inside the chart
            ctx.restore();
        }
    };

    const data = {
        labels: ['Promoters', 'Passives', 'Detractors'],
        datasets: [{
            label: 'Values',
            data: chartData ? [chartData[0].promoters, chartData[0].passive, chartData[0].detractors] : [],
            backgroundColor: backgroundColor,
            borderColor: '#fff',
            borderWidth: 0,
            respondentCounts: chartData ? [chartData[0].promoters_count, chartData[0].passive_count, chartData[0].detractors_count] : [],
        }]
    };

    const options = {
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        const dataset = tooltipItem.dataset;
                        const dataIndex = tooltipItem.dataIndex;
                        const value = tooltipItem.raw;
                        
                        const respondentCount = dataset.respondentCounts && dataset.respondentCounts[dataIndex] !== undefined
                                ? dataset.respondentCounts[dataIndex]
                                : 'N/A';                            
                        return `${dataset.label}: ${value}% | Count: ${respondentCount}`;
                    }
                },
                titleFont: {
                    family: 'Graphik-Light, sans-serif',
                    letterSpacing: 1.5,
                    size: 12,
                },
                bodyFont: {
                    family: 'Graphik-Light, sans-serif',
                    letterSpacing: 1.5,
                    size: 11
                },
                footerFont: {
                    family: 'Graphik-Light, sans-serif',
                    letterSpacing: 1.5,
                    size: 10
                }
            },
            legend: {
                display: false,
                position: 'bottom', // Set legend to display below the chart
                align: 'center',
                labels: {
                    color: '#000',
                    boxWidth: 20,
                    padding: 10,
                    font: {
                        size: 12,
                        family: 'VisbyCF-Medium, sans-serif',
                        letterSpacing: 1.5,
                    },
                    generateLabels: (chart) => {
                        const { datasets } = chart.data;
                        return chart.data.labels.map((label, index) => {
                            const value = datasets[0].data[index]; // Access the corresponding value
                            // If value is undefined, set it to 0
                            const displayValue = value !== undefined ? value : 0; 
    
                            return {
                                text: `${label}: ${displayValue}`, // Display label and value
                                fillStyle: datasets[0].backgroundColor[index],
                                strokeStyle: '#fff',
                                lineWidth: 3,
                                hidden: false,
                                index,
                            };
                        });
                    },
                }
            },
            datalabels: {
                display: false
            },
        },
        responsive: true,
        maintainAspectRatio: false,
        cutout: '87%', // Adjust size of the hole (87% of the chart's radius)
    };

    return (
        <div className="App nps-Chart h-w-100 text-align-center">
            <div className="height-200px">
                <Doughnut key={chartData ? chartData[0].nps : 'no-data'} data={data} options={options} plugins={[customPlugin]} />
            </div>
            {/* Add the bank name below the chart */}
            <div className={`family-Graphik-regular fs-18 margin-top-10 ${isSelfReport ? 'orange' : 'green'}-color`}
             >
                {chartData ? (chartData[0].main_bank) : ""}
            </div>
            {/* Custom legend section */}
            <div className="custom-legend custom-legend-section black-color">
                {data.labels.map((label, index) => (
                    <div key={index} className="custom-legend-div">
                        <div className="width-100px">
                            <span className="fs-14 family-Graphik-Light float-right">{`${data.datasets[0].data[index]+'%' || 0+'%'}`}</span>
                        </div>
                        <span 
                        // className="custom-legend-div-bg-dataset " 
                        className={`custom-legend-div-bg-dataset legend-color-${index} ${isSelfReport ? 'self' : 'competitor'}-chart`}/>
                        <div className="text-start width-100px">
                            <span className="fs-14 family-Graphik-Light">
                                {`${label}`}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}